import GeneralModal from './container';

export default GeneralModal;



// WEBPACK FOOTER //
// ./src/components/GeneralModal/index.js